import React, { useMemo } from 'react';
import { format } from 'date-fns';
import './styles/MeetingCard.css';

function parseMeetingDate(date) {
  if (!date) return null;
  try {
    return date.toDate ? date.toDate() : new Date(date);
  } catch {
    return null;
  }
}

const MeetingCard = ({ meeting, onClick }) => {
  const {
    clientName,
    additionalClients = [],
    title,
    dateTime,
    status,
  } = meeting;

  const startDate = useMemo(() => parseMeetingDate(dateTime), [dateTime]);

  const timeLabel = startDate ? format(startDate, 'h:mm a') : '--';
  const dateLabel = startDate ? format(startDate, 'EEE, MMM d') : 'No date';
  const yearLabel = startDate ? format(startDate, 'yyyy') : '';

  const normalizedStatus = String(status || 'pending')
    .trim()
    .toLowerCase()
    .replace(/[_\s-]+/g, ' ');

  const statusClass =
    normalizedStatus === 'confirmed'
      ? 'confirmed'
      : normalizedStatus === 'cancelled'
        ? 'cancelled'
        : normalizedStatus === 'completed'
          ? 'completed'
          : 'pending';

  const extraCount = additionalClients.length || 0;
  const withLine =
    extraCount > 0
      ? `With ${clientName || 'Client'} + ${extraCount} other${extraCount > 1 ? 's' : ''}`
      : `With ${clientName || 'Client'}`;

  return (
    <button
      type="button"
      className={`meeting-card meeting-card--${statusClass}`}
      onClick={() => onClick && onClick(meeting)}
    >
      <div className="meeting-card__time-rail">
        <span className="meeting-card__time">{timeLabel}</span>
        <span className="meeting-card__date">{dateLabel}</span>
        {yearLabel ? <span className="meeting-card__year">{yearLabel}</span> : null}
        <div className="meeting-card__badges">
          <span className={`meeting-card__status meeting-card__status--${statusClass}`}>
            {normalizedStatus}
          </span>
        </div>
      </div>

      <div className="meeting-card__content">
        <h3 className="meeting-card__title">{title || 'Meeting'}</h3>

        <div className="meeting-card__details">
          <span className="meeting-card__attendees">{withLine}</span>
        </div>
      </div>
    </button>
  );
};

export default React.memo(MeetingCard);
